import React, { Component } from 'react';
// import theme from '../../app.theme';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import BulletinIconOutlined from '@material-ui/icons/TurnedInNot';
import BulletinIcon from '@material-ui/icons/TurnedIn';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import ContextMenuIcon from '@material-ui/icons/MoreHoriz';
import { ThemeColors } from '../../theme';


class Card extends Component {

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.contextMenuItems = this.setContextMenuIcons();
  }

  handlePinContent = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const pinContentDto = {
      contentType: 'card',
      contentId: this.props.card.id,
    };

    this.props.pinOrUnpinContent(this.props.bulletinBoard.id, pinContentDto);
  }

  handleOpenContextMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ anchorEl: event.currentTarget });
  }

  setContextMenuIcons() {
    const menuItems = [];
    const bulletinText = this.props.isPinned
    ? 'Von meinen Inhalten entfernen'
    : 'Zu meinen Inhalten hinzufügen';


    if (!this.props.config) return [];

    if (this.props.config && this.props.config.sharingEnabled === 'true') {
      menuItems.push(
        <MenuItem onClick={this.props.onClickShare}>Als PDF herunterladen</MenuItem>,
        );
    }

    if (this.props.config && this.props.config.bulletinBoardActive === 'true') {
      menuItems.push(
        <MenuItem onClick={this.handlePinContent}>{bulletinText}</MenuItem>,
      );
    }

    return menuItems;
  }

  renderContextMenuIcon() {
    const { classes } = this.props;

    // if (!this.props.allowPinningContent) return null;
    if (!this.contextMenuItems || this.contextMenuItems.length < 1) return null;

    return (
      <div className={classes.contextMenuIconContainerStyle}>
        <ContextMenuIcon className={classes.iconsStyle} onClick={this.handleOpenContextMenu} />
      </div>
    );
  }

  renderContextMenu() {
    return (
      <Menu
        id="context-menu"
        anchorEl={this.state.anchorEl}
        keepMounted
        open={this.state.anchorEl}
        onClose={() => this.setState({ anchorEl: null })}
      >
        {this.contextMenuItems}
      </Menu>
    );
  }

  renderPath = () => {
    const groupPath = this.props.card.groupName
        ? <span style={{ color: 'black' }}>{this.props.card.groupName} > </span>
        : null;

    return <Typography component="div" style={{ color: 'lightgrey' }}>{groupPath}{this.props.card.courseName}</Typography>;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={`col-xs-12 col-sm-4 col-lg-3 col-md-3 ${classes.cardContainer}`} onClick={this.props.onClick}>
        <div className={classes.titleContainer}>
          <Typography style={{ textAlign: 'center' }}>{this.props.card.title}</Typography>
          {this.renderContextMenuIcon()}
        </div>
        <div className={classes.pathContainer}>
          {this.renderPath()}
          <div className={classes.iconContainer}>
            <BulletinIcon style={{ color: ThemeColors.accent1Color, cursor: 'pointer' }} onClick={this.handlePinContent} />
          </div>
        </div>
        {this.renderContextMenu()}
      </div>
    );
  }
}

Card.defaultProps = {
  title: '',
};

const styles = {
  title: {
    marginTop: '10px',
    paddingLeft: '30px',
    paddingRight: '15px',
    marginBottom: 0,
    position: 'absolute',
    bottom: '5px',
    width: '100%',
    hyphens: 'auto',
    WebkitHyphens: 'auto',
    wordWrap: 'break-word',
  },
};

const style = theme => ({
  cardContainer: {
    // display: 'flex',
    // flexDirection: 'row',
    // width: '100%',
    marginBottom: 10,
    // borderBottomColor: '#ddd',
    // borderBottomWidth: 1,
    // borderRightColor: '#ddd',
    // borderRightWidth: 1,
    // borderRightStyle: 'solid',
    // borderBottomStyle: 'solid',

  },
  titleContainer: {
    backgroundColor: theme.palette.primary.main,
    // width: '100%',
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.textOnBackground,
    padding: 5,
  },
  pathContainer: {
    border: '1px solid #ddd',
    padding: 5,
    minHeight: 50,
    maxHeight: 100,
    display: 'flex',
    justifyContent: 'space-between',
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
  contextMenuIconContainerStyle: {
    position: 'absolute',
    top: 2,
    right: 16,
    zIndex: 100,
    cursor: 'pointer',
  },
  iconsStyle: {
    zIndex: 1000,
    height: 25,
    width: 25,
    margin: 2,
    color: 'black',
    backgroundColor: 'white', // 'rgba(255, 255, 255, 0.75)',
    borderRadius: '100%',
  },
});

export default withStyles(style)(Card);



// WEBPACK FOOTER //
// ./src/app/components/tile/card-tile.js